import { Pipe, PipeTransform } from '@angular/core';
import { APP_CONSTANTS } from '../constants/constants';

@Pipe({
  name: 'serviceName'
})
export class ServiceNamePipe implements PipeTransform {

  transform(serviceType: string | undefined): string {
    if (!serviceType) return 'N/A';

    switch (serviceType.toLowerCase()) {
      case 'fixedprice':
        return APP_CONSTANTS.FIXEDPRICE;
      case 'hourlyrate':
        return APP_CONSTANTS.HOURLYRATE;
      case 'corporate':
        return APP_CONSTANTS.CORPORATE;
      case 'sales':
        return APP_CONSTANTS.SALES;
      case 'warehouseservice':
        return APP_CONSTANTS.WAREHOUSESERVICE;
      case 'warehousesalary':
        return APP_CONSTANTS.WAREHOUSE_PRICE_SALRY;
      case 'hourlyratesalary':
        return APP_CONSTANTS.HOURLY_PRICE_SALRY;
      case 'fixedpricesalary':
        return APP_CONSTANTS.FIXED_PRICE_SALRY;
      default:
        return '';
    }
  }

}
